/* eslint no-unused-vars: 0, vars-on-top: 0 */
require('babel-polyfill');

var $ = require('jquery');
var _ = require('lodash');
var csrftoken = require('common/csrftoken');
var bsoAnalytics = require('common/api/bso_analytics');
var bs4css = require('scss/_custom.scss');
var bootstrap = require('bootstrap/dist/js/bootstrap.js');
var profileWizardCSS = require('scss/styles_checkout_alt.scss');
var React = require('react');
var ReactDOM = require('react-dom');
var { createStore, combineReducers, applyMiddleware } = require('redux');
var { syncHistoryWithStore, routerReducer, routerMiddleware } = require('react-router-redux');
var { Provider } = require('react-redux');
var ReduxThunk = require('redux-thunk').default;
var router = require('react-router');
var constants = require('./constants');
var { SubscriptionApp } = require('./app');


// All changes to state will happen inside the following redcucers
var reducers = combineReducers({
  routing: routerReducer
});

// ReduxThunk - to dispatch async actions
// routerMiddleware - to dispatch router navigation actions
var middleware = applyMiddleware(ReduxThunk, routerMiddleware(router.browserHistory));

// Setup the redux store.
var initialState = {};
var store = createStore(reducers, initialState, middleware);

// Create an enhanced history that syncs navigation events with the store
var history = syncHistoryWithStore(router.browserHistory, store);
// How do I watch for navigation events, such as for analytics?
// history.listen(location => analyticsService.track(location.pathname))


// global listener for "working" progress indicator
$(document)
  .ajaxStart(() => $('.loading').show())
  .ajaxStop(() => $('.loading').hide())
  .ready(() => {
    $('.close-beta-notice').click((e) => {
      e.preventDefault();
      $('.beta-notice').hide();
    });
  });

function trackViewContent() {
  if (window.analytics) {
    window.analytics.track('ViewContent', {},
      { integrations: { 'All': false, 'Facebook Pixel': true, 'Webhooks': true }
    });
  }
}

function trackPageView() {
  if (window.analytics) {
    window.analytics.page({
      url: window.location.href,
      title: window.document.title,
      path: window.location.pathname
    });
  }

  if (window.parselyTrackPageView) {
    window.parselyTrackPageView({
      url: window.location.href,
      js: 1 // flag indicating this is dynamic
    });
  }
}

function onEnterPlanScreen() {
  document.title = 'Select a plan to get started | Subscribe to Backstage';
  window.scrollTo(0, 0);
  trackPageView();
  trackViewContent();
}

function onEnterAccountScreen() {
  document.title = 'Create your account | Subscribe to Backstage';
  window.scrollTo(0, 0);
  trackPageView();
  trackViewContent();
}

function onEnterPaymentScreen() {
  document.title = 'Payment details | Subscribe to Backstage';
  window.scrollTo(0, 0);
  trackPageView();
  trackViewContent();
}

function onEnterReviewScreen() {
  document.title = 'Review your order | Subscribe to Backstage';
  window.scrollTo(0, 0);
  trackPageView();
  trackViewContent();
}

function onEnterConfirmationScreen() {
  document.title = 'Thanks for signing up with Backstage!';
  window.scrollTo(0, 0);
  trackPageView();
}

ReactDOM.render((
  <Provider store={store}>
    <router.Router history={router.browserHistory}>
      <router.Route path={constants.APP_ROOT}>
        <router.IndexRedirect to={`${constants.APP_ROOT}${_.get(window, 'detected_currency', 'usd').toLowerCase()}/plans/`} />
        {/*
          * :currency
          * :type => offer | role
          * :status => new | renew
          */}
        <router.Route path=":currency/(:type/):status/thanks/" step={4} component={SubscriptionApp} onEnter={onEnterConfirmationScreen} />
        <router.Route path=":currency/(:type/):status/confirm/" step={3} component={SubscriptionApp} onEnter={onEnterReviewScreen} />
        <router.Route path=":currency/(:type/):status/checkout/" step={2} component={SubscriptionApp} onEnter={onEnterPaymentScreen} />
        <router.Route path=":currency/(:type/):status/account/" step={1} component={SubscriptionApp} onEnter={onEnterAccountScreen} />
        <router.Route path=":currency/(:type/)(:status/)plans/" step={0} component={SubscriptionApp} onEnter={onEnterPlanScreen} />
      </router.Route>
    </router.Router>
  </Provider>
), document.getElementById('app__container'));



// WEBPACK FOOTER //
// ./bso/frontend/static/js/subscribe/index.js